module.exports = __webpack_public_path__ + "img/clorex.2db13e49.png";